import { notification } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons"

// Define the valid placement options for Ant Design notifications
type NotificationPlacement =
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight"

/**
 * Display an error notification.
 * @param message - The message to be displayed in the notification.
 * @param desc - The description of the notification.
 * @param placement - The placement of the notification. Defaults to "topRight".
 * @returns void
 */
const ErrorNotification = (
  message: string,
  desc: string,
  placement: NotificationPlacement = "topRight"
): void => {
  notification.open({
    message: message,
    duration: 5,
    description: desc,
    placement: placement,
    icon: (
      <FontAwesomeIcon
        icon={faCircleExclamation}
        style={{ color: "#A91B0D", height: "1.2em" }}
      />
    ),
  })
}

/**
 * Display a success notification.
 * @param message - The message to be displayed in the notification.
 * @param desc - The description of the notification.
 * @param placement - The placement of the notification. Defaults to "topRight".
 * @returns void
 */
const SuccessNotification = (
  message: string,
  desc: string,
  placement: NotificationPlacement = "topRight"
): void => {
  notification.open({
    message: message,
    duration: 5,
    description: desc,
    placement: placement,
    icon: (
      <FontAwesomeIcon
        icon={faCircleCheck}
        style={{ color: "#41c219", height: "1.2em" }}
      />
    ),
  })
}

export { ErrorNotification, SuccessNotification }
